function isEven(num: number) {
  return num % 2 === 0;
}
export { isEven };
